import React from "react";
import { colorPredictionTransferbalanceAPI } from "../../service/AuthService";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const ColorPredictionTransferBalance = () => {
  const [amount, setAmount] = React.useState("");
  const userData = useSelector((state) => state.account.userData);
  const handleTransfer = async () => {
   try { const { code } = await colorPredictionTransferbalanceAPI(
      amount,
      userData?.username,
      "LOTUS121",
    );
    if (code === 200) {
      toast.success("Balance transferred successfully");
    } else {
      toast.error("Failed to transfer balance");
    }
    } catch (error) {
        toast.error("An error occurred while transferring balance");
    }
  };
  return (
    <div className="">
      <input
        type="number"
        value={amount}
        className=""
        onChange={(e) => setAmount(e.target.value)}
        placeholder="Enter amount to transfer"
      />
      <button className="" onClick={handleTransfer}>
        Transfer Balance to Color Prediction
      </button>
    </div>
  );
};
export default ColorPredictionTransferBalance;
